import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Header.scss';

const Header: React.FC = () => {
  const [logoError, setLogoError] = useState(false);
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  const scrollToSection = (sectionId: string) => {
    if (!isHomePage) {
      // If not on home page, navigate to home first
      window.location.href = `/#${sectionId}`;
      return;
    }
    
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header className="header">
      <nav className="nav container">
        <Link to="/" className="logo">
          {!logoError ? (
            <img 
              src="/logo-black.svg" 
              alt="Shadow Tracker Logo" 
              className="logo-image"
              onError={() => setLogoError(true)}
            />
          ) : (
            <span className="logo-text">Shadow Tracker</span>
          )}
        </Link>
        <div className="nav-links">
          <Link to="/" className={isHomePage ? 'active' : ''}>Shadow Tracker</Link>
          <Link to="/starlink" className={location.pathname === '/starlink' ? 'active' : ''}>Starlink</Link>
          {isHomePage && (
            <>
              <button onClick={() => scrollToSection('features')}>Features</button>
              <button onClick={() => scrollToSection('how-it-works')}>How It Works</button>
              <button onClick={() => scrollToSection('videos')}>Videos</button>
              <button onClick={() => scrollToSection('pricing')}>Buy Now</button>
            </>
          )}
        </div>
      </nav>
    </header>
  );
};

export default Header;
